import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _Symbol$iterator from "@babel/runtime-corejs3/core-js-stable/symbol/iterator";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof _Symbol && "symbol" == typeof _Symbol$iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof _Symbol && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function isObject(x) {
  return x !== null && _typeof(x) === 'object';
}